<div id="info-dialog">
  <h1 mat-dialog-title>¡Importante!</h1>
  <div mat-dialog-content>
    <p>{{ data.message }}</p>
  </div>
  <div mat-dialog-actions id="info-dialog-buttons">
    <ng-container *ngIf="data.buttons">
      <button
        *ngFor="let btn of data.buttons"
        mat-button
        type="button"
        (click)="openUrl(btn.url, btn.target)">
        {{ btn.label }}
      </button>
    </ng-container>
    <button mat-button mat-dialog-close>{{ data.closeButton }}</button>
  </div>
</div>